import { FC } from 'react';
import { ExcelImportResult } from '../../models/fees';
import { ImportDialog, ExcelData, ExcelRow } from './ImportDialog';

interface ImportFeeConfigurationsDialogProps {
  visible: boolean;
  onClose: () => void;
  onImport: (file: File) => Promise<ExcelImportResult>;
}

interface FeeConfigPreview {
  hudLines: Set<string>;
  totalRows: number;
  ruleTypes: Set<string>;
}

export const ImportFeeConfigurationsDialog: FC<ImportFeeConfigurationsDialogProps> = ({
  visible,
  onClose,
  onImport,
}) => {
  return (
    <ImportDialog<FeeConfigPreview>
      visible={visible}
      onClose={onClose}
      onImport={onImport}
      title="Import Fee Configurations"
      entityName="fee configurations"
      parsePreview={(dataRows: ExcelData) => {
        const hudLines = new Set<string>();
        const ruleTypes = new Set<string>();

        dataRows.forEach((row: ExcelRow) => {
          if (row[0]) hudLines.add(String(row[0]).trim());
          if (row[4]) ruleTypes.add(String(row[4]).trim());
        });

        return {
          hudLines,
          totalRows: dataRows.length,
          ruleTypes,
        };
      }}
      renderPreview={(preview: FeeConfigPreview, fileName: string) => (
        <div className="surface-100 p-3 border-round">
          <h4 className="mt-0 mb-3">Import Preview</h4>
          <div className="flex flex-column gap-3">
            <div className="flex justify-content-between">
              <span className="font-semibold">File:</span>
              <span>{fileName}</span>
            </div>
            <div className="flex justify-content-between">
              <span className="font-semibold">Total Rules:</span>
              <span className="text-xl text-blue-600 font-bold">{preview.totalRows}</span>
            </div>
            <div className="flex justify-content-between">
              <span className="font-semibold">Rule Types:</span>
              <span className="text-blue-600 font-semibold">{Array.from(preview.ruleTypes).join(', ')}</span>
            </div>
          </div>
        </div>
      )}
    />
  );
};
